<router-outlet></router-outlet>

<!-- for spinner -->
<ng-http-loader></ng-http-loader>
